import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

export const TopTrades: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="top-trades bg-lvl2 bg-secondary bg-opacity-10">
      <div className="card mb-0" style={{ backgroundColor: 'transparent' }}>
        <div className="card-header ps-3 pe-3 pt-3">
          <h6 className="mb-0">{formatMessage({ id: 'discover.topTrades.title', defaultMessage: 'Top trades' })}</h6>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};
